/*
* @Description: 公共常量和函数
* @Author: Jinger
* @Date: 2022-12-28 17:02:40
*/

/**
 * 解析url或get请求：去掉?和&，返回 { key1: value1, key2: value2 ...}
 */
function getParams(url) {
  let res = {};
  if (url.indexOf("?") !== -1) {
    let str = url.substr(1);
    let arr = str.split("&");

    for(let i = 0, len = arr.length; i < len; i ++) {
      // 截取key:value

      // 方法1：通过decodeURI 或 decodeURIComponent 进行解码
      // res[arr[i].split("=")[0]] = decodeURIComponent(arr[i].split("=")[1]);

      // 方法2：value中有特殊字符 如"="（token中带有=）
      if (arr[i].indexOf("=") !== -1) {
        res[arr[i].slice(0, arr[i].indexOf("="))] = arr[i].slice(arr[i].indexOf("=") + 1);
      }
    }
  }
  return res;
}

export { getParams };